export const TABLE_COLUMNS = [
  'status',
  'date',
  'wallet',
  'withdrawalWallet',
  'details',
  'amount',
  'id_transaction'
];

export const AMOUNT_COLUMN = 'amount';
export const WITHDRAWAL_WALLET_FIELD = 'withdrawalWallet';
export const WALLET_FIELD = 'wallet';
export const ID_COLUMN = 'id';

export const STATUS_TYPES = {
  IN_PROGRESS: 'pending',
  SUCCESS: 'completed',
  CANCELED: 'canceled'
} as const;

export const CANCEL_REASONS = {
  PLAYER: '0',
  BANK: '1',
  ADMINISTRATION: '2',
  TECHNICAL_ERROR: '3'
} as const;

export const STATUS_LABELS = {
  [STATUS_TYPES.IN_PROGRESS]: 'web.balance.deposithistory.filter.state_1',
  [STATUS_TYPES.SUCCESS]: 'web.balance.deposithistory.filter.state_2',
  [STATUS_TYPES.CANCELED]: 'web.balance.deposithistory.filter.state_3'
} as const;
